import './input.scss';

const Input = ({ value, onChange, disabled = false, ...rest }) => {
    return <input value={value} onChange={onChange} className="app-input" disabled={disabled} {...rest} />
}

export default Input;